export default "__VITE_ASSET__BwUWyEGm__"